import config from '../config';
import { http, httpFormData } from '../framework/api';

/**
 * Validates selfie quality via Azure Face API.
 * @param {File} selfieFile
 */
export const validateSelfie = (selfieFile) => () => {
    const formData = new FormData();
    formData.append('selfie', selfieFile);
    const url = `${config.API_ROOT_URL}/face-verification/validate-selfie`;
    return httpFormData('POST', url, formData);
};

/**
 * Validates selfie quality and compares it against an ID photo.
 * @param {File} selfieFile
 * @param {File} idPhotoFile
 */
export const matchFace = (selfieFile, idPhotoFile) => () => {
    const formData = new FormData();
    formData.append('selfie', selfieFile);
    formData.append('idPhoto', idPhotoFile);
    const url = `${config.API_ROOT_URL}/face-verification/match`;
    return httpFormData('POST', url, formData);
};

/**
 * Creates a new mobile capture session (authenticated).
 * Returns { Token, ExpiresAt }.
 */
export const createCaptureSession = () => () => {
    const url = `${config.API_ROOT_URL}/face-verification/session`;
    return http('POST', url, null);
};

/**
 * Polls the status of a capture session (authenticated).
 * Returns { Status, ImageBase64 }.
 * @param {string} token - session GUID
 */
export const pollCaptureSession = (token) => () => {
    const url = `${config.API_ROOT_URL}/face-verification/session/${token}`;
    return http('GET', url, null);
};

/**
 * Uploads the captured selfie from the mobile device (anonymous — token is the credential).
 * @param {string} token - session GUID
 * @param {File} imageFile
 */
export const uploadMobileCapture = (token, imageFile) => () => {
    const formData = new FormData();
    formData.append('image', imageFile);
    const url = `${config.API_ROOT_URL}/face-verification/session/${token}`;
    return httpFormData('PUT', url, formData, false);
};

/**
 * Sets verification status to ManualVerificationNeeded (authenticated).
 */
export const requestManualReview = () => () => {
    const url = `${config.API_ROOT_URL}/face-verification/request-manual-review`;
    return http('POST', url, null);
};

/**
 * Analyzes an ID document image using Azure Document Intelligence.
 * Extracts structured fields and validates against business rules.
 * @param {File} idImageFile
 */
export const analyzeDocument = (idImageFile) => () => {
    const formData = new FormData();
    formData.append('idImage', idImageFile);
    const url = `${config.API_ROOT_URL}/document-verification/analyze`;
    return httpFormData('POST', url, formData);
};
